import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-nav-button',
  templateUrl: './back-nav-button.component.html',
  styleUrls: ['./back-nav-button.component.scss']
})
export class BackNavButtonComponent implements OnInit {

  @Input() backUrl: string;
  @Input() text: string;
  @Input() class: string;

  constructor() { }

  ngOnInit(): void {
  }

}
